import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import "@/App.css";
import { AuthProvider } from "@/lib/auth";
import { SettingsProvider } from "@/lib/settings";
import { pageview } from "@/lib/analytics";
import { Toaster } from "sonner";

import PublicLayout from "@/components/PublicLayout";
import HomePage from "@/pages/HomePage";
import ProductsPage from "@/pages/ProductsPage";
import ProductDetailPage from "@/pages/ProductDetailPage";
import ClassesPage from "@/pages/ClassesPage";
import SubscriptionsPage from "@/pages/SubscriptionsPage";
import EventChefPage from "@/pages/EventChefPage";
import BlogPage from "@/pages/BlogPage";
import BlogPostPage from "@/pages/BlogPostPage";
import FAQPage from "@/pages/FAQPage";
import SupportPage from "@/pages/SupportPage";
import PaymentSuccessPage from "@/pages/PaymentSuccessPage";
import SignInPage from "@/pages/SignInPage";
import SignUpPage from "@/pages/SignUpPage";
import AccountPage from "@/pages/AccountPage";
import AuthCallbackPage from "@/pages/AuthCallbackPage";

import AdminLoginPage from "@/pages/admin/AdminLoginPage";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminProducts from "@/pages/admin/AdminProducts";
import AdminOrders from "@/pages/admin/AdminOrders";
import AdminBlog from "@/pages/admin/AdminBlog";
import AdminFAQs from "@/pages/admin/AdminFAQs";
import AdminMessages from "@/pages/admin/AdminMessages";
import AdminChatbot from "@/pages/admin/AdminChatbot";
import AdminSettings from "@/pages/admin/AdminSettings";

function AppRouter() {
  // Handle Google OAuth callback session_id in URL fragment BEFORE normal routes mount
  if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
    return <AuthCallbackPage />;
  }
  return (
    <>
      <RouteTracker />
      <Routes>
      <Route element={<PublicLayout />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/products" element={<ProductsPage />} />
        <Route path="/products/:id" element={<ProductDetailPage />} />
        <Route path="/classes" element={<ClassesPage />} />
        <Route path="/subscriptions" element={<SubscriptionsPage />} />
        <Route path="/event-chef" element={<EventChefPage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:slug" element={<BlogPostPage />} />
        <Route path="/faq" element={<FAQPage />} />
        <Route path="/support" element={<SupportPage />} />
        <Route path="/payment-success" element={<PaymentSuccessPage />} />
        <Route path="/payment-cancel" element={<SupportPage />} />
        <Route path="/signin" element={<SignInPage />} />
        <Route path="/signup" element={<SignUpPage />} />
        <Route path="/account" element={<AccountPage />} />
        <Route path="/auth/callback" element={<AuthCallbackPage />} />
      </Route>

      <Route path="/admin/login" element={<AdminLoginPage />} />
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<AdminDashboard />} />
        <Route path="products" element={<AdminProducts />} />
        <Route path="orders" element={<AdminOrders />} />
        <Route path="blog" element={<AdminBlog />} />
        <Route path="faqs" element={<AdminFAQs />} />
        <Route path="messages" element={<AdminMessages />} />
        <Route path="chatbot" element={<AdminChatbot />} />
        <Route path="settings" element={<AdminSettings />} />
      </Route>
    </Routes>
    </>
  );
}

// Fires a GA4 page_view on every SPA route change.
function RouteTracker() {
  const loc = useLocation();
  useEffect(() => { pageview(loc.pathname + loc.search); }, [loc.pathname, loc.search]);
  return null;
}

function App() {
  return (
    <SettingsProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <AppRouter />
        </BrowserRouter>
      </AuthProvider>
    </SettingsProvider>
  );
}

export default App;
